// extracted by mini-css-extract-plugin
export default {"tooltip":"jU-z","arrow":"kU-z"};